import axios from "axios";
import { trackPromise } from "react-promise-tracker";
import { eraseCookie, getCookie } from "../../Utils";

export default class Service {
  constructor(path, baseURL) {
    if (!baseURL) {
      baseURL = process.env.REACT_APP_NOT_SECRET_CODE ?? "/";
    }
    if (path) {
      baseURL += path;
    }
    this.service = this.axiosInstance(baseURL);
    this.service.interceptors.response.use(this.handleSuccess, this.handleError);
  }

  axiosInstance(baseURL) {
    let headers = { csrf: "token" };
    let service = axios.create({
      baseURL,
      headers: headers,
    });
    service.interceptors.request.use((config) => {
      if (getCookie("jwToken")) config.headers.Authorization = "Bearer " + getCookie("jwToken");
      return config;
    });
    service.defaults.headers.common["Accept"] = "application/json;charset=UTF-8";
    service.defaults.headers.common["Content-Type"] = "application/json;charset=UTF-8";
    return service;
  }

  handleSuccess(response) {
    // if (response.data && response.data.isSuccess === false) {
    //   SnackbarUtils.error("Error!");
    // }
    return response;
  }

  handleError = async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const result = await trackPromise(this.axiosInstance().post(`api/authenticate/RefreshToken`));
        if (result) {
          if (getCookie("jwToken")) originalRequest.headers.Authorization = "Bearer " + getCookie("jwToken");
          return await trackPromise(axios.request(originalRequest));
        }
      } catch (err) {
        console.log(err);
        eraseCookie("jwToken");
        eraseCookie("refreshToken");
        this.redirectTo(document, "/");
      }
    }
    switch (error.response.status) {
      case 401:
        // this.redirectTo(document, "/");
        break;
      case 404:
        // this.redirectTo(document, "/404");
        break;
      case 400:
      case 500:
        // SnackbarUtils.error("Error!");
        // this.redirectTo(document, "/500");
        break;
      default:
        // this.redirectTo(document, "/500");
        break;
    }
    // SnackbarUtils.error("Error!");
    return Promise.reject(error);
  };

  redirectTo = (document, path) => {
    document.location = path;
  };

  async get(path, callback, timeout) {
    const response = await trackPromise(
      this.service.get(path, { timeout: timeout ?? 0 }).catch((error) => {
        return error.response;
      })
    );
    return callback(response?.status, response?.data);
  }

  async getWithoutTracker(path, callback) {
    const response = await this.service.get(path);
    return callback(response?.status, response?.data);
  }

  async patch(path, payload, callback) {
    const response = await trackPromise(
      this.service
        .request({
          method: "PATCH",
          url: path,
          responseType: "json",
          data: payload,
        })
        .catch((error) => {
          return error.response;
        })
    );
    return callback(response.status, response.data);
  }

  async post(path, payload, callback, responseType) {
    const response = await trackPromise(
      this.service
        .request({
          method: "POST",
          url: path,
          responseType: responseType ?? "json",
          data: payload,
        })
        .catch((error) => {
          return error.response;
        })
    );
    return callback(response.status, response.data);
  }

  async postWithoutTracker(path, payload, callback, responseType) {
    const response = await this.service
      .request({
        method: "POST",
        url: path,
        responseType: responseType ?? "json",
        data: payload,
      })
      .catch((error) => {
        return error.response;
      });
    return callback(response.status, response.data);
  }

  async put(path, payload, callback) {
    const response = await trackPromise(
      this.service
        .request({
          method: "PUT",
          url: path,
          responseType: "json",
          data: payload,
        })
        .catch((error) => {
          return error.response;
        })
    );
    return callback(response.status, response.data);
  }

  async delete(path, callback) {
    const response = await trackPromise(
      this.service
        .request({
          method: "DELETE",
          url: path,
          responseType: "json",
        })
        .catch((error) => {
          return error.response;
        })
    );
    return callback(response.status, response.data);
  }
}
